import { useState } from "react";
import {
    GuxButton,
    GuxButtonSlot,
    GuxFormFieldCheckbox,
    GuxFormFieldTextLike,
    GuxModal,
} from "genesys-spark-components-react";
import strings from "./SaveQuestionTemplate.strings";
import "./SaveQuestionTemplate.less";
import { useStrings } from "features/i18n/useStrings";
import { saveQuestionAsTemplate } from "features/templates/templateSlice";
import toastService from "services/toastService";
import { useAppDispatch } from "app/hooks";

export function SaveQuestionAsTemplateButton({
    questionId,
}: {
    questionId: string;
}) {
    const [showModal, setShowModal] = useState(false);
    const t = useStrings(strings);

    return (
        <>
            <GuxButton onClick={() => setShowModal(true)}>
                <span>{t.labels.saveTemplate}</span>
            </GuxButton>
            {showModal && (
                <SaveQuestionTemplate
                    isOpened={showModal}
                    questionId={questionId}
                    clear={() => setShowModal(false)}
                />
            )}
        </>
    );
}

export function SaveQuestionTemplate({
    isOpened,
    questionId,
    clear,
}: {
    isOpened: boolean;
    questionId: string;
    clear: () => void;
}) {
    const dispatch = useAppDispatch();
    const [templateName, setTemplateName] = useState("");
    const [markedFavorite, setMarkedFavorite] = useState(false);
    const t = useStrings(strings);

    return (
        <div className="SaveQuestionTemplate">
            <GuxModal open={isOpened} size="small" onGuxdismiss={() => clear()}>
                <div slot="title" className="gux-heading-lg-bold">
                    {t.labels.createQuestionTemplate}
                </div>
                <div slot="content">
                    <GuxFormFieldTextLike
                        clearable
                        label-position="above"
                        className="help-text"
                    >
                        <label slot="label">{t.labels.templateName}</label>
                        <input
                            value={templateName}
                            slot="input"
                            type="text"
                            placeholder={t.labels.addTemplateName}
                            onChange={({ currentTarget }) => {
                                setTemplateName(currentTarget.value);
                            }}
                        />
                    </GuxFormFieldTextLike>
                    <div className="favorite-template">
                        <GuxFormFieldCheckbox>
                            <input
                                slot="input"
                                type="checkbox"
                                name="favoriteTemplate"
                                checked={markedFavorite}
                                onChange={() =>
                                    setMarkedFavorite(!markedFavorite)
                                }
                                className="Clickable"
                            />
                            <label slot="label" className="Clickable">
                                {t.labels.favoriteTemplate}
                            </label>
                        </GuxFormFieldCheckbox>
                    </div>
                </div>
                <div slot="end-align-buttons">
                    <GuxButtonSlot accent="primary">
                        <button
                            type="button"
                            onClick={() => {
                                dispatch(
                                    saveQuestionAsTemplate({
                                        questionId: questionId,
                                        templateName: templateName,
                                        setFavorite: markedFavorite,
                                    })
                                ).then((e) => {
                                    if ("error" in e) {
                                        toastService.notifyMinorAlert(
                                            "qualityFormEditor.question.toastMessage.fail.title",
                                            {
                                                bodyMessageKey:
                                                    "qualityFormEditor.question.toastMessage.fail.message",
                                            }
                                        );
                                    } else {
                                        toastService.notifyMessage(
                                            "qualityFormEditor.question.toastMessage.success.title",
                                            {
                                                bodyMessageKey:
                                                    "qualityFormEditor.question.toastMessage.success.message",
                                                icon: "fa-check-circle",
                                            },
                                            false
                                        );
                                    }
                                });

                                clear();
                            }}
                        >
                            {t.labels.save}
                        </button>
                    </GuxButtonSlot>
                </div>
                <div slot="start-align-buttons">
                    <GuxButtonSlot>
                        <button
                            id="cancel-button"
                            type="button"
                            onClick={() => clear()}
                        >
                            {t.labels.cancel}
                        </button>
                    </GuxButtonSlot>
                </div>
            </GuxModal>
        </div>
    );
}
